export const setUserClubs = (state, { clubIds }) => {
  // TO TEST when error 404 is handled by MindFlurry
  const clubs = state.clubs;
  const myClubs = clubs.filter((club) => clubIds.includes(club.id));
  state = state.setIn(['userClubs'], myClubs);
  return state;
};
